module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3-shh/~/websocket/lib/version.js
// module id = 1973
// module chunks = 0 1 3